import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaginationDTO } from '../../../common/types/responses/responses-template';
import {
  NotificationDTO,
  NotificationType,
} from '../../shared/dtos/notifications.dto';
import {
  NOTIFICATION_FILTERS,
  NOTIFICATION_TYPE_META,
  NotificationFilter,
  notificationLink,
  notificationTitle,
} from '../../shared/helpers/notification-type.helpers';
import { NotificationsService } from '../../shared/services/notifications/notifications.service';

@Component({
  selector: 'app-notifications-page',
  templateUrl: './notifications-page.component.html',
  styleUrl: './notifications-page.component.scss',
  standalone: false,
})
export class NotificationsPageComponent implements OnInit {
  notifications: NotificationDTO[] | null = null;

  listMeta: PaginationDTO;

  activeFilter: NotificationType | 'all' = 'all';

  filters: NotificationFilter[] = NOTIFICATION_FILTERS;

  typeMeta = NOTIFICATION_TYPE_META;

  notificationTitle = notificationTitle;

  pageSize = 20;

  customCollapsed = false;

  constructor(
    private notificationsService: NotificationsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchNotifications();
  }

  get selectedFilterLabel(): string {
    return this.filters.find((f) => f.key === this.activeFilter)?.label ?? '';
  }

  goToNotificationSource(notification: NotificationDTO): void {
    const link = notificationLink(notification);
    if (!link) {
      return;
    }
    this.router.navigateByUrl(link);
  }

  toggleCustomCollapsed(): void {
    this.customCollapsed = !this.customCollapsed;
  }

  setFilter(key: NotificationType | 'all'): void {
    this.customCollapsed = false;
    if (this.activeFilter === key) {
      return;
    }
    this.activeFilter = key;
    this.listMeta = undefined as unknown as PaginationDTO;
    this.fetchNotifications();
  }

  fetchNotifications(): void {
    const notificationType =
      this.activeFilter === 'all' ? undefined : this.activeFilter;
    const page = this.listMeta?.currentPage || 1;

    this.notificationsService
      .getNotifications(false, notificationType, {
        page,
        per_page: this.pageSize,
      })
      .subscribe((res) => {
        this.notifications = res?.items || [];
        this.listMeta = res?._meta;
        this.markCurrentPageAsRead();
      });
  }

  private markCurrentPageAsRead(): void {
    const ids = (this.notifications || [])
      .filter((n) => !n.date_shown)
      .map((n) => n.id);

    if (!ids.length) {
      return;
    }

    this.notificationsService.markNotificationAsRead(ids).subscribe(() => {
      const now = Math.floor(Date.now() / 1000);
      this.notifications?.forEach((n) => {
        if (ids.includes(n.id)) {
          n.date_shown = now;
        }
      });
    });
  }
}
